import React, { memo } from "react";
import { withStyles } from "@material-ui/core/styles";
import FormSectionHeader from "../common/FormSectionHeader";
import { WarningOutlined as WarningOutlinedIcon } from "@material-ui/icons";
import { BULK_VOID_DISCLAIMER_MSG } from "../constants";
import { isBulkVoidPickupMode } from "../utils";

const styles = (theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
    border: `1px solid ${theme.AppBGColor}`,
    borderRadius: "4px",
    padding: 8,
    gap: 6,
  },
  pickupChip: {
    paddingRight: 8,
    color: theme.TextColor,
    fontSize: theme.textFontSize,
    fontWeight: 600,
  },
  empty: {
    color: theme.disabledColor,
    fontSize: theme.textFontSize,
  },
  disclaimerContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    background: theme.warningBGColor,
    padding: 8,
  },
  warningIcon: {
    color: theme.warningTextColorDispatch,
    marginRight: 9,
  },
  message: {
    color: theme.warningTextColorDispatch,
    fontWeight: 500,
    fontSize: theme.headerTextFontSize,
  }
});

const SelectedPickupsInfo = ({ classes, pickupNumbers = [], mode }) => {
  const count = pickupNumbers.length;

  return (
    <div id="selectedPickupsInfo">
      <FormSectionHeader label={`Selected Pickups (${count})`} />

      {/* Pickup list */}
      <div className={classes.container}>
        {count === 0 ? (
          <span className={classes.empty}>No pickups selected</span>
        ) : (
          pickupNumbers.map((pickupNumber, index) => (
            <span key={pickupNumber} className={classes.pickupChip}>
              {pickupNumber}
              {index !== count - 1 && ","}
            </span>
          ))
        )}
      </div>

      {/* Warning below */}
      {isBulkVoidPickupMode(mode) && (
        <div className={classes.disclaimerContainer}>
          <WarningOutlinedIcon className={classes.warningIcon} />
          <span className={classes.message}>
            {BULK_VOID_DISCLAIMER_MSG}
          </span>
        </div>
      )}
    </div>
  );
};

export default withStyles(styles)(memo(SelectedPickupsInfo));